import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '@mui/material';
import { Stack } from '@mui/system';

import ModalNotification from '@/shared/components/dialogs/ModalNotification';
import User from '@/shared/types/user';

type DisableCurrentUserConfirmationDialogProps = {
  user: User;
  errors?: string[];
  onClose: () => void;
  onProceedDisableUser: (user: User) => void;
};

const DisableCurrentUserConfirmationDialog: FC<
  DisableCurrentUserConfirmationDialogProps
> = ({ user, errors, onClose, onProceedDisableUser }) => {
  const { t } = useTranslation(['usersManagement', 'common']);

  if (errors?.length) {
    return (
      <ModalNotification
        size='xs'
        fullWidth
        open
        onClose={onClose}
        dialogProps={{
          title: t('common:error'),
          content: (
            <Stack spacing={2} useFlexGap>
              {t('bookingsServices:disableCurrentUserError')}
              {errors.map((error) => (
                <Alert key={error} severity='error'>
                  {error}
                </Alert>
              ))}
            </Stack>
          ),
          actions: [
            {
              label: t('common:close'),
              onClick: onClose,
            },
          ],
        }}
      />
    );
  }

  return (
    <ModalNotification
      size='xs'
      fullWidth
      open
      onClose={onClose}
      dialogProps={{
        title: t('usersManagement:disableCurrentUser'),
        content: (
          <Alert severity='warning'>
            {t('usersManagement:disableCurrentUserConfirmation')}
          </Alert>
        ),
        actions: [
          {
            label: t('common:close'),
            onClick: onClose,
          },
          {
            label: t('common:confirm'),
            variant: 'contained',
            color: 'error',
            onClick: () => {
              onProceedDisableUser(user);
            },
          },
        ],
      }}
    />
  );
};

export default DisableCurrentUserConfirmationDialog;
